import { IonCard } from "@ionic/react";
import React from "react";
import { EventEntry } from "../../models";

interface ItemCardProps {
    currentEventEntry: EventEntry;
    /** 1-based entry number shown above the horse name when provided */
    entryNumber?: number;
}

const BasicEntryInfoCard: React.FC<ItemCardProps> = ({ currentEventEntry, entryNumber }) => {
    const horseName = currentEventEntry.horseName?.trim() || "Horse";
    const riderOne = currentEventEntry.riderName?.trim() || "Rider";
    const riderTwo = currentEventEntry.secondRiderName?.trim() || currentEventEntry.secondRider?.name?.trim();
    const ridersLine = riderTwo ? `${riderOne} & ${riderTwo}` : riderOne;

    return (
        <IonCard className="rounded-3 mx-0 bg-lighter entry-info-card">
            <div className="entry-info-card__row">
                <div className="entry-info-card__icon">
                    <span className="entry-info-card__icon-emoji">🐴</span>
                </div>
                <div className="entry-info-card__text">
                    {entryNumber != null ? <div className="text-info entry-info-card__eyebrow">Entry {entryNumber}</div> : null}
                    <div className="text-primary entry-info-card__title">{horseName}</div>
                    <div className="text-primary entry-info-card__subtitle">{ridersLine}</div>
                </div>
            </div>
        </IonCard>
    );
};

export default BasicEntryInfoCard;
